<div class="titulo-pagina">Gerir atos</div>

<ng-container>
    <form #form="ngForm" (ngSubmit)="buscar(true)" novalidate>
        <fieldset>
            <legend>Filtros de pesquisa</legend>
            <suite-rfb-collapse title="Filtros de pesquisa">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-3" autofocus>
                                <label class="control-label">ID do ato</label>
                                <input [(ngModel)]="filtro.idAto" type="text" class="form-control" name="idAto" maxlength="8"
                                    suiteRfbNumbersOnly>
                            </div>
                            <div class="col-sm-6">
                        
                                <suite-rfb-select label="Tipo do ato" [customBody]="true" unselectedLabel="Todos">
                                    <ng-select class="chips multiple form-control select-menor" [multiple]="true" bindLabel="nomeTipoAto"
                                        [items]="tiposAto" name="tipo" [(ngModel)]="listaTipoAtoSelecionada" placeholder="Todos">
                                        <ng-template ng-option-tmp let-item="item">
                                            <span class="select-menor">{{item.nomeTipoAto}}</span>
                                        </ng-template>
                                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                            <div class="ng-value" *ngFor="let item of items">
                                                <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
                                                <span class="ng-value-label">{{item.siglaTipoAto}}</span>
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                </suite-rfb-select>
                        
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label for="numeroAto" class="control-label">Número do ato</label>
                                    <input type="text" name="numeroAto" class="form-control" [(ngModel)]="filtro.numeroAto" maxlength="20">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-5">
                    
                        <suite-rfb-select label="Órgãos / unidades" [customBody]="true" unselectedLabel="Todos">
                            <ng-select class="chips multiple form-control select-menor" [multiple]="true"
                                bindLabel="label" [items]="orgaos" name="orgao" [(ngModel)]="listaOrgaosSelecionados"
                                placeholder="Todos">
                                <ng-template ng-option-tmp let-item="item">
                                    <span class="select-menor">{{item.siglaOrgao}} - {{item.nomeOrgao}}</span>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value" *ngFor="let item of items">
                                        <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
                                        <span class="ng-value-label">{{item.siglaOrgao}}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </suite-rfb-select>
                    
                    </div>
                    <div class="col-sm-1">
                        <label class="control-label">Ano do ato</label>
                        <input [(ngModel)]="filtro.anoAto" type="text" class="form-control" name="anoAto" maxlength="4"
                            suiteRfbNumbersOnly>
                    </div>
                </div>
                <suite-rfb-collapse title="Outros filtros de pesquisa" [(collapsed)]="!pesquisaAvancada">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col-sm-5">
                                    <suite-rfb-date-picker label="Data do ato" name="dataAto" [(ngModel)]="filtro.dataAtoInicial" 
                                        [outsideClick]="true" inputGroupClass="input-group date data-menor">
                                    </suite-rfb-date-picker>
                                </div>
                                <div class="col-sm-2" style="padding-left: 0px;">
                                    <div style="text-align: center; color: #00205b; padding-top: 10px; font-size: 13px;">Repetir</div>
                                    <div style="text-align: center; color: #00205b;">
                                        <a (click)="repetirDataAto()" title="Repetir data do ato">
                                            <em class="material-icons icon-24">arrow_forward</em>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <suite-rfb-date-picker label="a" name="dataAtoFinal" [(ngModel)]="filtro.dataAtoFinal"
                                        [outsideClick]="true" inputGroupClass="input-group date data-menor">
                                    </suite-rfb-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2" style="padding-left: 20px;">
                            <label class="control-label">Liberado para consulta</label>
                            <div class="form-group" style="display: flex; flex-wrap: wrap;">
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="situacao" value="0" (change)="onChangeSituacao($event)"
                                        [checked]="filtro.situacao === 0 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Indiferente</label>
                                </div>
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="situacao" value="1" (change)="onChangeSituacao($event)"
                                        [checked]="filtro.situacao === 1 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Sim</label>
                                </div>
                                <div>
                                    <input type="radio" name="situacao" value="2" (change)="onChangeSituacao($event)"
                                        [checked]="filtro.situacao === 2 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Não</label>
                                </div>
                            </div>
                        </div> 
                        <div class="col-sm-2" style="padding-left: 20px;">
                            <label class="control-label">Ementa no resultado</label>
                            <div class="form-group" style="display: flex; flex-wrap: wrap;">
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="exibirEmenta" value="0" [checked]="!filtro.exibirEmenta ? 'checked' : null" 
                                        (change)="onChangeExibirEmenta($event)">
                                    <label class="control-label label-margin-left-5">Ocultar</label>
                                </div>
                                <div>
                                    <input type="radio" name="exibirEmenta" value="1" [checked]="filtro.exibirEmenta ? 'checked' : null"
                                        (change)="onChangeExibirEmenta($event)">
                                    <label class="control-label label-margin-left-5">Exibir</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Observações do ato</label>
                                <input type="text" name="observacaoAto" class="form-control" [(ngModel)]="filtro.observacaoAto" maxlength="100">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col-sm-5">
                                    <suite-rfb-date-picker label="Data da publicação" name="dataPublicacaoInicial"
                                        [(ngModel)]="filtro.dataPublicacaoInicial" [outsideClick]="true" inputGroupClass="input-group date data-menor">
                                    </suite-rfb-date-picker>
                                </div>
                                <div class="col-sm-2" style="padding-left: 0px;">
                                    <div style="text-align: center; color: #00205b; padding-top: 10px; font-size: 13px;">Repetir</div>
                                    <div style="text-align: center; color: #00205b;">
                                        <a (click)="repetirDataPublicacao()" title="Repetir data de publicação">
                                            <em class="material-icons icon-24">arrow_forward</em>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <suite-rfb-date-picker label="a" name="dataPublicacaoFinal" [(ngModel)]="filtro.dataPublicacaoFinal"
                                        [outsideClick]="true" inputGroupClass="input-group date data-menor">
                                    </suite-rfb-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4" style="padding-left: 20px;">
                            <label class="control-label">Visões</label>
                            <div class="form-group" style="display: flex; flex-wrap: wrap;">
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="visao" value="0" (change)="onChangeTipoVisao($event)"
                                        [checked]="filtro.tipoVisao === 0 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Indiferente</label>
                                </div>
                                <div>
                                    <input type="radio" name="visao" value="1" (change)="onChangeTipoVisao($event)"
                                        [checked]="filtro.tipoVisao === 1 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Apenas as selecionadas:</label>
                                </div>
                            </div>
                            <div *ngIf= "filtro.tipoVisao === 1" class="form-group" style="display: flex; flex-wrap: wrap;">
                                <div style="margin-right: 15px;">
                                    <input type="checkbox" (change)="onChangeVisao($event, 0)"
                                        [checked]="filtro.exibirVisoes.charAt(0) === '1' ? 'checked' : null" value="0">
                                    <label class="control-label label-margin-left-5">Original</label>
                                </div>
                                <div style="margin-right: 15px;">
                                    <input type="checkbox" (change)="onChangeVisao($event, 1)"
                                        [checked]="filtro.exibirVisoes.charAt(1) === '1' ? 'checked' : null" value="1">
                                    <label class="control-label label-margin-left-5">Multivigente</label>
                                </div>
                                <div style="margin-right: 15px;">
                                    <input type="checkbox" (change)="onChangeVisao($event, 2)"
                                        [checked]="filtro.exibirVisoes.charAt(2) === '1' ? 'checked' : null" value="2">
                                    <label class="control-label label-margin-left-5">Vigente</label>
                                </div>
                                <div>
                                    <input type="checkbox" (change)="onChangeVisao($event, 3)"
                                        [checked]="filtro.exibirVisoes.charAt(3) === '1' ? 'checked' : null" value="3">
                                    <label class="control-label label-margin-left-5">Relacional</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <suite-rfb-select label="Assunto" name="assunto" [labels]="labelsAssunto" [values]="assuntos"
                                [multiple]="true" [(ngModel)]="listaAssuntosSelecionados" [clearable]="true" unselectedLabel="Todos"
                                selectClass="form-control wrapText select-menor">
                            </suite-rfb-select>
                        </div>  
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col-sm-5">
                                    <suite-rfb-date-picker label="Início da vigência" name="dataVigenciaInicio"
                                        [(ngModel)]="filtro.dataInicioVigenciaInicial" [outsideClick]="true" inputGroupClass="input-group date data-menor">
                                    </suite-rfb-date-picker>
                                </div>
                                <div class="col-sm-2" style="padding-left: 0px;">
                                    <div style="text-align: center; color: #00205b; padding-top: 10px; font-size: 13px;">Repetir</div>
                                    <div style="text-align: center; color: #00205b;">
                                        <a (click)="repetirDataInicioVigencia()" title="Repetir início da vigência">
                                            <em class="material-icons icon-24">arrow_forward</em>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <suite-rfb-date-picker label="a" name="dataVigenciaFinal"
                                        [(ngModel)]="filtro.dataInicioVigenciaFinal" [outsideClick]="true" inputGroupClass="input-group date data-menor">
                                    </suite-rfb-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2" style="padding-left: 20px;">
                            <label class="control-label">Exibição na internet</label>
                            <div class="form-group" style="display: flex; flex-wrap: wrap;">
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="exibicaoInternet" value="0" (change)="onChangeExibirInternet($event)"
                                        [checked]="filtro.exibicaoInternet === 0 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Indiferente</label>
                                </div>
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="exibicaoInternet" value="1" (change)="onChangeExibirInternet($event)"
                                        [checked]="filtro.exibicaoInternet === 1 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Sim</label>
                                </div>
                                <div>
                                    <input type="radio" name="exibicaoInternet" value="2" (change)="onChangeExibirInternet($event)"
                                        [checked]="filtro.exibicaoInternet === 2 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Não</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6" style="padding-left: 20px;">

                            <suite-rfb-select label="Área responsável" [customBody]="true" unselectedLabel="Todos">
                                <ng-select class="chips multiple form-control select-menor" [multiple]="true" bindLabel="label"
                                    [items]="orgaos" name="areaResponsavel" [(ngModel)]="listaAreasResponsaveisSelecionadas" placeholder="Todas">
                                    <ng-template ng-option-tmp let-item="item">
                                        <span class="select-menor">{{item.siglaOrgao}} - {{item.nomeOrgao}}</span>
                                    </ng-template>
                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <div class="ng-value" *ngFor="let item of items">
                                            <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
                                            <span class="ng-value-label">{{item.siglaOrgao}}</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </suite-rfb-select>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col-sm-5">
                                    <suite-rfb-date-picker label="Fim da vigência" name="dataFimVigencia"
                                        [(ngModel)]="filtro.dataFimVigenciaInicial" [outsideClick]="true" inputGroupClass="input-group date data-menor">
                                    </suite-rfb-date-picker>
                                </div>
                                <div class="col-sm-2" style="padding-left: 0px;">
                                    <div style="text-align: center; color: #00205b; padding-top: 10px; font-size: 13px;">Repetir</div>
                                    <div style="text-align: center; color: #00205b;">
                                        <a (click)="repetirDataFimVigencia()" title="Repetir fim da vigência">
                                            <em class="material-icons icon-24">arrow_forward</em>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <suite-rfb-date-picker label="a" name="dataFimVigenciaFinal" iconSize="24px"
                                        [(ngModel)]="filtro.dataFimVigenciaFinal" [outsideClick]="true" inputGroupClass="input-group date data-menor">
                                    </suite-rfb-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2" style="padding-left: 20px;">
                            <label class="control-label">Exibição no Sijut-1</label>
                            <div class="form-group" style="display: flex; flex-wrap: wrap;">
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="exibicaoSijut1" value="0" (change)="onChangeExibirSijut1($event)"
                                        [checked]="filtro.exibicaoSijut1 === 0 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Indiferente</label>
                                </div>
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="exibicaoSijut1" value="1" (change)="onChangeExibirSijut1($event)"
                                        [checked]="filtro.exibicaoSijut1 === 1 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Sim</label>
                                </div>
                                <div>
                                    <input type="radio" name="exibicaoSijut1" value="2" (change)="onChangeExibirSijut1($event)"
                                        [checked]="filtro.exibicaoSijut1 === 2 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">Não</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4" style="padding-left: 20px;">
                            <label class="control-label">Local da publicação</label>
                            <div class="form-group" style="display: flex; flex-wrap: wrap;">
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="local" value="0" (change)="onChangeLocal($event)"
                                        [checked]="filtro.idLocalPublicacao === 0 ? 'checked' : true">
                                    <label class="control-label label-margin-left-5">Indiferente</label>
                                </div>
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="local" value="1" (change)="onChangeLocal($event)"
                                        [checked]="filtro.idLocalPublicacao === 1 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">DOU</label>
                                </div>
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="local" value="2" (change)="onChangeLocal($event)"
                                        [checked]="filtro.idLocalPublicacao === 2 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">BP/MF</label>
                                </div>
                                <div style="margin-right: 15px;">
                                    <input type="radio" name="local" value="3" (change)="onChangeLocal($event)"
                                        [checked]="filtro.idLocalPublicacao === 3 ? 'checked' : null">
                                    <label class="control-label label-margin-left-5">BS/RFB</label>
                                </div>
                                <div>
                                    <input type="radio" name="local" value="4" (change)="onChangeLocal($event)"
                                        [checked]="filtro.idLocalPublicacao === 4 ? 'checked' : null">
                                    <span class="control-label label-margin-left-5">
                                        Outro
                                        <input type="text" *ngIf="filtro.idLocalPublicacao === 4" name="localPublicacao"
                                            class="form-control" [(ngModel)]="filtro.textoLivre" maxlength="20000" size="100">
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" *ngIf="filtro.idLocalPublicacao === 1 || filtro.idLocalPublicacao === 3">
                                        <label for="secao" class="control-label">Seção</label>
                                        <input type="text" name="secao" class="form-control" [(ngModel)]="filtro.secao">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group" *ngIf="filtro.idLocalPublicacao === 1 || filtro.idLocalPublicacao === 3">
                                        <label for="pagina" class="control-label">Página</label>
                                        <input type="text" name="pagina" class="form-control" [(ngModel)]="filtro.numeroPagina" maxlength="6"
                                            suiteRfbNumbersOnly>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </suite-rfb-collapse>
                <div class="row">
                    <div class="col-sm-6"></div>
                    <div class="col-sm-6">
                        <div class="form-group" style="margin-top: 25px; text-align: right;">
                            <button type="button" class="btn btn-marrom" (click)="limpar(); verAtosDeHoje()">Ver atos de hoje</button>
                            <button type="button" class="btn btn-default" (click)="limpar()">Limpar</button>
                            <button type="submit" class="btn btn-primary">Buscar</button>
                        </div>
                    </div>
                </div>
            </suite-rfb-collapse>
        </fieldset>
        
    </form>
</ng-container>

<ng-container *ngIf="atos && atos.length > 0">
    <div class="tabela-links" id="ancora">
        <suite-rfb-pagination [(itemAmount)]="atos.length" [(pageSize)]="pageSize" [(page)]="currentPage">
        </suite-rfb-pagination>
    </div>
    <div class="table-responsive">
        <table suiteRfbTable tableClass="table table-striped tabela">
            <caption>ATOS - QUANTIDADE DE RESULTADOS: {{ atos.length }}</caption>
            <thead>
                <tr>
                    <th class="text-center">
                        <span>ID do ato</span>
                        <suite-rfb-sort-by [asc]="sortedBy[0]"
                            (onSort)="sortByColuna(0, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Tipo</span>
                        <suite-rfb-sort-by [asc]="sortedBy[1]"
                            (onSort)="sortByColuna(1, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Número do ato</span>
                        <suite-rfb-sort-by [asc]="sortedBy[2]"
                            (onSort)="sortByColuna(2, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Órgao/unidade</span>
                        <suite-rfb-sort-by [asc]="sortedBy[3]"
                            (onSort)="sortByColuna(3, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Data do ato</span>
                        <suite-rfb-sort-by [asc]="sortedBy[4]"
                            (onSort)="sortByColuna(4, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Data da publicação</span>
                        <suite-rfb-sort-by [asc]="sortedBy[5]"
                            (onSort)="sortByColuna(5, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Situação</span>
                        <suite-rfb-sort-by [asc]="sortedBy[6]" (onSort)="sortByColuna(6, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Internet</span>
                        <suite-rfb-sort-by [asc]="sortedBy[7]" (onSort)="sortByColuna(7, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Sijut-1</span>
                        <suite-rfb-sort-by [asc]="sortedBy[8]" (onSort)="sortByColuna(8, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center" *ngIf="exibirEmentaTela">
                        <span>Ementa</span>
                    </th>
                    <th class="text-center" colspan="1">
                        Ações
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ato of atos | currentPage:currentPage" [style]="ato.republicacao?{'background-color': '#fccfd1'}:{}">
                    <td class="text-center">
                        {{ ato.idAto }}
                    </td>
                    <td class="text-center">
                        {{ ato.siglaTipoAto }}
                    </td>
                    <td class="text-center">
                        {{ ato.numeroAto }}
                    </td>
                    <td class="text-center">
                        <span *ngIf="!ato.orgaos || ato.orgaos.length === 0">{{ ato.orgaosStr }}</span>
                        <span *ngIf="ato.orgaos && ato.orgaos.length > 0">
                            <span *ngFor="let orgao of ato.orgaos; let i=index">
                                <span class="texto" title="{{ orgao.nome }}">{{ orgao.sigla }}</span>
                                <span class="texto" *ngIf="i < ato.orgaos.length - 1"> | </span>
                            </span>
                        </span>
                    </td>
                    <td class="text-center">
                        {{ ato.dataAtoStr }}
                    </td>
                    <td class="text-center">
                        {{ ato.dataPublicacaoStr }}
                    </td>
                    <td class="text-center">
                        {{ ato.publicado ? "Liberado" : "Não liberado" }}
                    </td>
                    <td class="text-center">
                        {{ ato.internet ? "Sim" : "Não"}}
                    </td>
                    <td class="text-center">
                        {{ ato.flags === '0' ? "Não" : "Sim" }}
                    </td>
                    <td class="text-center" *ngIf="exibirEmentaTela">
                        <span title="{{ ato.ementa }}">
                            {{ getEmenta(ato.ementa) }}
                        </span>
                    </td>
                    <td class="text-center">
                        <a (click)="visualizarAto(ato)" target="_blank">
                            <span title="Visualizar ato" container="body">
                                <span class="material-icons icon-24">visibility</span>
                            </span>
                        </a>
                        <span>&nbsp;</span>

                        <a [routerLink]="['/atos/corrigir-ato', ato.idAto]" target="_blank">
                            <span title="Corrigir ato" container="body">
                                <span class="material-icons icon-24">edit_note</span>
                            </span>
                        </a>
                        <span>&nbsp;</span>

                        <a [routerLink]="['/atos/republicar-ato', ato.idAto]" *ngIf="!ato.republicacao" target="_blank">
                            <span title="Republicar ato" container="body">
                                <span class="material-icons icon-24">published_with_changes</span>
                            </span>
                        </a>
                        <span *ngIf="!ato.republicacao">&nbsp;</span>

                        <suite-rfb-confirmation-link *ngIf="!ato.republicacao && ato.idAtoRepublicado" popupTitle="Excluir republicação"
                            (accept)="excluirRepulicacao(ato)"
                            question="Confirma exclusão do ato republicador '{{ato.idAto}}'?">
                            <span title="Excluir republicação" container="body">
                                <span class="material-icons icon-24">sync_disabled</span>
                            </span>
                        </suite-rfb-confirmation-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="tabela-links">
        <suite-rfb-pagination [(itemAmount)]="atos.length" [(pageSize)]="pageSize" [(page)]="currentPage" (pageChange)="subirParaTopoResultado()">
        </suite-rfb-pagination>
    </div>
</ng-container>
